import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=5a7bd242&"
import script from "./Personalization.vue?vue&type=script&lang=js&"
export * from "./Personalization.vue?vue&type=script&lang=js&"
import style0 from "./Personalization.vue?vue&type=style&index=0&id=5a7bd242&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports